import React, { useMemo } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from "@coreui/react";
import { CChartLine } from "@coreui/react-chartjs";
import { fmtInt } from "../../utils/chartHelpers";

export default function WaiterDetailModal({ waiterName, datas = [], onClose }) {
  const labels = useMemo(() => datas.map((d) => d.date ?? "—"), [datas]);
  const values = useMemo(() => datas.map((d) => Number(d.sumInt) || 0), [datas]);
  const total = useMemo(() => values.reduce((a, b) => a + b, 0), [values]);

  return (
    <CModal visible={!!waiterName} onClose={onClose} size="lg" scrollable>
      <CModalHeader>
        <CModalTitle>{waiterName} — по дням</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {datas.length > 0 ? (
          <>
            <CChartLine
              data={{
                labels,
                datasets: [
                  {
                    label: "Выручка",
                    data: values,
                    borderColor: "#321fdb",
                    backgroundColor: "rgba(50, 31, 219, 0.1)",
                    tension: 0.3,
                  },
                ],
              }}
              options={{ maintainAspectRatio: true }}
            />
            <CTable small hover responsive className="mt-3">
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>Дата</CTableHeaderCell>
                  <CTableHeaderCell>Выручка</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {[...datas].reverse().map((d, idx) => (
                  <CTableRow key={`${d.date}-${idx}`}>
                    <CTableDataCell>{d.date}</CTableDataCell>
                    <CTableDataCell>{fmtInt(d.sumInt)} ₽</CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
            <p className="fw-semibold mb-0">Итого: {fmtInt(total)} ₽</p>
          </>
        ) : (
          <p className="text-body-secondary mb-0">Нет дневных данных.</p>
        )}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Закрыть
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
